import React from 'react';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';

import FormInput from '../../checkout/molecules/FormInput';
import { SOFT_TOMATO } from '../../colors';

const Form = styled.div``;

const ButtonSubmit = styled.button`
  width: 100%;
  border: none;
  background-color: ${SOFT_TOMATO};
  color: white;
  border-radius: 6px;
  height: 40px;
  font-family: 'Poppins-SemiBold';
  font-size: 0.8rem;
  margin: 0.5rem 0rem;

  &:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
    color: #666;
  }
`;

const ErrorText = styled.span`
  color: red;
  font-size: 0.75rem;
`;

interface LoginFormProps {
  disabled?: boolean;
  onSubmit?: (email: string, password: string) => void;
}

const LoginForm = ({
  disabled = false,
  onSubmit,
}: LoginFormProps) => {

  const {
    register,
    handleSubmit,
    formState: {
      errors, isValid
    },
    watch
  } = useForm({
    mode: 'onChange'
  })

  const onPressSubmit = () => {
    handleSubmit((data) => {
      onSubmit?.(data.email,data.password);
    })();
  }

  return (
    <Form>
      <FormInput 
        placeholder="EMAIL ADDRESS" 
        type="email"
         {...register('email', {
            required: `Field is required`.toUpperCase(),
            pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Basic email regex
            message: 'Enter a valid email address'.toUpperCase(),
          }, 
        })}
      />
      {errors.email && <ErrorText>{errors.email.message?.toString()}</ErrorText>}
      <FormInput 
        placeholder="PASSWORD" 
        type="password"
        {...register('password', {
          required: `Field is required`.toUpperCase(),
          minLength: {
            value: 8,
            message: 'PASSWORD must be at 8 characters'.toUpperCase(),
          },
          maxLength: {
            value: 20,
            message: 'PASSWORD must be at most 20 characters'.toUpperCase(),
          },
        })}
      />
       {errors.password && <ErrorText>{errors.password.message?.toString()}</ErrorText>}
      <ButtonSubmit
        onClick={onPressSubmit}
        disabled={!isValid || disabled}
      >
        LOGIN
      </ButtonSubmit>
    </Form>
  )
}

export default LoginForm;